var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"crouton-placeholder",attrs:{"data-crouton":_vm.$options.methods.optionsFromProps(_vm.props)}})}
var staticRenderFns = []

export { render, staticRenderFns }